export default __webpack_public_path__ + "static/media/future.7f428d25.jpeg";